import { render, staticRenderFns } from "./UpdateCustomerAddress.vue?vue&type=template&id=60e8caa8&scoped=true"
import script from "./UpdateCustomerAddress.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8caa8",
  null
  
)

export default component.exports